import api from './api';

const BASE = '/nabl-support';

const nablSupportService = {
  syncTickets: () => api.post(`${BASE}/sync`),
  getStats: () => api.get(`${BASE}/stats`),
  getTickets: (params) => api.get(`${BASE}/tickets`, { params: { ...params, excludeClosed: params.excludeClosed ?? false } }),
  getTicketThreads: (ticketNumber) => api.get(`${BASE}/tickets/${ticketNumber}/threads`),
  updateTicketStatus: (ticketNumber, status) => api.patch(`${BASE}/tickets/${ticketNumber}/status`, { status }),
  getUsers: () => api.get(`${BASE}/users`),
  getAllAssignments: () => api.get(`${BASE}/assignments`),
  getTicketAssignments: (ticketNumber) => api.get(`${BASE}/tickets/${ticketNumber}/assignments`),
  assignTicket: (ticketNumber, userIds) => api.post(`${BASE}/tickets/${ticketNumber}/assign`, { userIds }),
  updateTicketType: (ticketNumber, ticketType) => api.patch(`${BASE}/tickets/${ticketNumber}/type`, { ticketType }),
  exportTickets: () => api.get(`${BASE}/export`),
  aiRephrase: (text, mode) => api.post(`${BASE}/ai/rephrase`, { text, mode }),
};

export default nablSupportService;
